import Vue from 'vue'
import router from './router';
import { BootstrapVue } from 'bootstrap-vue'
import VuePlyr from 'vue-plyr'
import VueLazyload from 'vue-lazyload'

import 'vue-plyr/dist/vue-plyr.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
Vue.use(BootstrapVue)
Vue.use(LottieVuePlayer);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/img/error.gif',
  loading: '/img/loading.gif',
  attempt: 1
})
Vue.use(VuePlyr, {
    plyr: {}
  })
 

import imageViewer from './directives/imageViewer'
Vue.directive('image-viewer', imageViewer)


import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import VueHoverSlider from 'vue-hover-slider'
Vue.use(VueHoverSlider)
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);
import Index from "./components/Index";


require('./bootstrap');

const app = new Vue({
    el: '#app',

    components: {
        Index
    },
    router
});
